import React from 'react';
import '../css/navBar.css';
import Tabla from './Tabla';

function MainEventos(){

    return(  
        <>  
            <div className='container container-width-85'>
                <h1 id="encabezado" className='py-4 text-white titulos'>Eventos</h1>          
                <Tabla seccionId={1}/>
            </div>
        </>
    );
}


export default MainEventos;